/* Pit Lane theme scripts: mobile nav, product page, cart drawer, account forms, product filters. No dependencies. */
(function () {
  'use strict';

  // Mobile navigation ---------------------------------------------------------
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Driver roster: Xbox / PlayStation filter ----------------------------------
  // Links like /#xbox and /#playstation open the roster already filtered.
  var roster = document.querySelector('[data-roster]');
  if (roster) {
    var tabs = roster.querySelectorAll('[data-filter]');
    var groups = roster.querySelectorAll('[data-group]');

    var applyFilter = function (filter) {
      if (filter !== 'xbox' && filter !== 'playstation') filter = 'all';
      groups.forEach(function (g) {
        g.hidden = !(filter === 'all' || g.getAttribute('data-group') === filter);
      });
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-filter') === filter;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    };

    var fromHash = function () {
      var h = window.location.hash.replace('#', '');
      if (h === 'xbox' || h === 'playstation' || h === 'all') applyFilter(h);
    };

    tabs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var f = t.getAttribute('data-filter');
        applyFilter(f);
        if (window.history && history.replaceState) history.replaceState(null, '', '#' + f);
      });
    });

    window.addEventListener('hashchange', fromHash);
    fromHash();
  }

  // Cart drawer ---------------------------------------------------------------
  // Progressive enhancement: with no drawer on the page (or no JS) every cart link and
  // Add to cart button falls back to the normal /cart page.
  var drawer = document.querySelector('[data-cart-drawer]');
  var drawerReady = !!drawer && !document.body.classList.contains('template-cart');
  var lastFocus = null;

  function cartUrl(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + path;
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    // force reflow so the slide-in transition runs
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.body.classList.add('no-scroll');
    var panel = drawer.querySelector('.drawer-panel');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderDrawer(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-cart-drawer]');
    var panel = drawer.querySelector('.drawer-panel');
    var nextPanel = next && next.querySelector('.drawer-panel');
    if (!panel || !nextPanel) return;
    panel.innerHTML = nextPanel.innerHTML;
    drawer.setAttribute('data-item-count', next.getAttribute('data-item-count'));
    setCount(parseInt(next.getAttribute('data-item-count'), 10) || 0);
  }

  function refreshDrawer() {
    return fetch(cartUrl('?section_id=cart-drawer'), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(renderDrawer);
  }

  function showDrawerError(msg) {
    var el = drawer && drawer.querySelector('[data-drawer-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = !msg;
  }

  function changeLine(line, quantity) {
    return fetch(cartUrl('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          var msg = data.description || data.message || 'Could not update the cart.';
          return refreshDrawer().then(function () { showDrawerError(msg); });
        }
        if (data.sections && data.sections['cart-drawer']) { renderDrawer(data.sections['cart-drawer']); return; }
        return refreshDrawer();
      })
      .catch(function () { window.location.href = cartUrl('cart'); });
  }

  if (drawerReady) {
    // Cart icon opens the drawer
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        refreshDrawer().then(openDrawer, function () { window.location.href = cartUrl('cart'); });
        return;
      }
      if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }

      var changer = e.target.closest('[data-line-change]');
      if (changer) {
        changeLine(parseInt(changer.getAttribute('data-line-change'), 10), parseInt(changer.getAttribute('data-qty'), 10));
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-input]');
      if (input) changeLine(parseInt(input.getAttribute('data-line-input'), 10), Math.max(0, parseInt(input.value, 10) || 0));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      // keep Tab focus inside the open drawer
      if (e.key === 'Tab' && drawer.classList.contains('is-open')) {
        var f = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Back/forward cache can show a stale cart
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshDrawer(); });
  }

  // Add to cart without leaving the page (product form)
  function ajaxAdd(form, btn) {
    var data = new FormData(form);
    data.append('sections', 'cart-drawer');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        btn.disabled = false;
        btn.textContent = label;
        if (!res.ok || res.body.status) {
          showAddError(form, res.body.description || res.body.message || 'Could not add this item.');
          return;
        }
        showAddError(form, '');
        if (res.body.sections && res.body.sections['cart-drawer']) renderDrawer(res.body.sections['cart-drawer']);
        else refreshDrawer();
        showDrawerError('');
        openDrawer();
      })
      .catch(function () { form.submit(); });
  }

  function showAddError(form, msg) {
    var el = form.querySelector('[data-add-error]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'form-err small';
      el.setAttribute('data-add-error', '');
      el.setAttribute('role', 'alert');
      form.appendChild(el);
    }
    el.textContent = msg;
    el.hidden = !msg;
  }

  // Customer account pages ----------------------------------------------------
  document.querySelectorAll('[data-toggle-target]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = document.getElementById(b.getAttribute('data-toggle-target'));
      if (t) t.hidden = !t.hidden;
    });
  });

  document.querySelectorAll('[data-delete-address]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!window.confirm(b.getAttribute('data-confirm') || 'Delete this address?')) return;
      var f = document.createElement('form');
      f.method = 'POST';
      f.action = b.getAttribute('data-delete-address');
      f.innerHTML = '<input type="hidden" name="_method" value="delete">';
      document.body.appendChild(f);
      f.submit();
    });
  });

  // Country -> state/province dropdowns (uses the data-provinces Shopify puts on each option)
  document.querySelectorAll('[data-address-country]').forEach(function (country) {
    var wrap = country.closest('form');
    var province = wrap && wrap.querySelector('[data-address-province]');
    var provinceWrap = wrap && wrap.querySelector('[data-address-province-wrap]');
    if (!province) return;

    function fill() {
      var opt = country.options[country.selectedIndex];
      var list = [];
      try { list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) { list = []; }
      province.innerHTML = '';
      if (!list.length) { provinceWrap.hidden = true; return; }
      provinceWrap.hidden = false;
      list.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0]; o.textContent = p[1];
        province.appendChild(o);
      });
      var want = province.getAttribute('data-default');
      if (want) province.value = want;
    }

    var dc = country.getAttribute('data-default');
    if (dc) country.value = dc;
    country.addEventListener('change', function () { province.setAttribute('data-default', ''); fill(); });
    fill();
  });

  // Product filters (collection + search) -------------------------------------
  // Works without JS too: the form simply submits as a normal GET request.
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm && window.fetch && window.URLSearchParams && window.DOMParser) {
    window.__pitFilters = true;
    document.documentElement.classList.add('js');

    var panel = filterForm.querySelector('[data-filter-panel]');
    var overlay = filterForm.querySelector('[data-filter-overlay], .filter-overlay');
    var openBtn = filterForm.querySelector('[data-filter-open]');

    var setPanel = function (open) {
      if (!panel) return;
      panel.classList.toggle('is-open', open);
      if (overlay) overlay.hidden = !open;
      document.body.classList.toggle('no-scroll', open);
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var first = panel.querySelector('summary, input, button'); if (first) first.focus(); }
      else if (openBtn) { openBtn.focus(); }
    };

    var buildUrl = function () {
      var params = new URLSearchParams();
      new FormData(filterForm).forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
      var qs = params.toString();
      return filterForm.getAttribute('action') + (qs ? '?' + qs : '');
    };

    var render = function (url, push) {
      var section = document.querySelector('[data-filter-section]');
      var focusId = document.activeElement && document.activeElement.id;
      section.setAttribute('aria-busy', 'true');
      section.classList.add('is-loading');
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('bad'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-filter-section]');
          if (!next) throw new Error('missing');
          ['[data-filter-results]', '[data-filter-facets]', '[data-result-count]'].forEach(function (sel) {
            var cur = section.querySelector(sel), nxt = next.querySelector(sel);
            if (cur && nxt) cur.innerHTML = nxt.innerHTML;
          });
          var sort = next.querySelector('#sort_by'), curSort = section.querySelector('#sort_by');
          if (sort && curSort) curSort.value = sort.value;
          if (push && history.pushState) history.pushState({ pitFilter: true }, '', url);
          if (focusId) { var f = document.getElementById(focusId); if (f && f.focus) f.focus(); }
        })
        .catch(function () { window.location.href = url; })
        .then(function () { section.removeAttribute('aria-busy'); section.classList.remove('is-loading'); });
    };

    filterForm.addEventListener('change', function () { render(buildUrl(), true); });
    filterForm.addEventListener('submit', function (e) { e.preventDefault(); render(buildUrl(), true); setPanel(false); });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-open]')) { setPanel(true); return; }
      if (e.target.closest('[data-filter-close]')) { setPanel(false); return; }
      var link = e.target.closest('[data-filter-link], .shop-results .pagination a');
      if (link && link.href && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        render(link.getAttribute('href'), true);
        var top = filterForm.getBoundingClientRect().top + window.pageYOffset - 100;
        if (link.closest('.pagination')) window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) setPanel(false);
    });

    window.addEventListener('popstate', function () { render(window.location.pathname + window.location.search, false); });
  }

  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var form = root.querySelector('form');
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var addBtn = root.querySelector('[data-add-btn]');
    var currency = root.getAttribute('data-currency') || 'USD';

    function money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('.opt'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    function showMedia(id) {
      if (!id) return;
      var found = false;
      root.querySelectorAll('.gallery-slide').forEach(function (el) {
        var on = el.getAttribute('data-media-id') === String(id);
        el.classList.toggle('is-active', on);
        if (on) found = true;
      });
      if (!found) return;
      root.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id));
      });
    }

    function updateUI(variant) {
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (variant.featured_media && variant.featured_media.id) showMedia(variant.featured_media.id);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('.opt input').forEach(function (input) {
      input.addEventListener('change', function () { updateUI(findVariant(selectedOptions())); });
    });

    // Add to cart: slide-out drawer when it's on, normal form post otherwise
    if (form && drawerReady) {
      form.addEventListener('submit', function (e) {
        if (addBtn.disabled) { e.preventDefault(); return; }
        e.preventDefault();
        ajaxAdd(form, addBtn);
      });
    }

    // Thumbnails
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); });
    });

    // Quantity buttons
    var qty = root.querySelector('[data-qty]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }
  }
  // Product page (runs last so the cart drawer helpers above are ready)
  document.querySelectorAll('[data-product-section]').forEach(initProduct);
})();
